import { FaArrowRight } from "react-icons/fa6";
import { FiFacebook, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import footer_bg from "../../Assets/Footer/footer_bg.png";

const socialIcons = [
  {
    name: "facebook",
    icon: FiFacebook,
    link: " https://www.facebook.com/profile.php?id=61565519471893",
  },
  {
    name: "instagram",
    icon: FiInstagram,
    link: " https://www.instagram.com/mixmasters.rmc",
  },
  // { name: "youtube", icon: FiYoutube, link: "https://youtube.com" },
  {
    name: "linkedin",
    icon: FiLinkedin,
    link: " https://www.linkedin.com/company/mixmasters-rmc",
  },
];

const footerSections = [
  {
    title: "Company",
    links: [
      { label: "About Us", path: "/about" },
      { label: "Career", path: "/carrier", badge: "Hiring!" },
      { label: "Projects", path: "/projects" },
      { label: "Testimonials", path: "/testimonials" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog / Articles", path: "/blog" },
      // { label: "Detail Guides", path: "/guides" },
      // { label: "FAQs", path: "/faq" },
      { label: "Help Center", path: "/contact" },
      { label: "Terms and Conditions", path: "/termsandconditions" },
    ],
  },
];

const UserFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="w-full px-4 sm:px-6 md:px-8 lg:px-10 relative py-14 text-white pb-0 bg-[#001a38]">
        {/* Texture */}
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage: `url(${footer_bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/10 pointer-events-none" />

        <div className="flex flex-col gap-y-12">
          {/* LOGO */}
          <div>
            <img
              src="/logo.png"
              className="h-16 sm:h-20 rounded-md"
              alt="logo"
            />
          </div>

          {/* MAIN GRID */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 lg:gap-12">
            {/* NEWSLETTER */}
            <div className="md:col-span-2 flex flex-col gap-y-5 sm:gap-y-6 max-w-full">
              <p className="text-white font-bold text-lg sm:text-xl md:text-2xl tracking-wide leading-snug">
                Stay Updated, Join MIX MASTER <br className="hidden sm:block" />
                Newsletter
              </p>

              <div className="flex flex-col sm:flex-row gap-2 w-full">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="w-full sm:flex-1 min-w-0
    px-3 sm:px-4 py-3
    rounded-lg outline-none
    focus:ring-2 focus:ring-primaryAccent
    text-sm text-gray-900"
                />

                <button
                  type="button"
                  className="group w-full sm:w-auto
    flex items-center justify-center gap-2 sm:gap-3
    px-4 sm:pl-6 sm:pr-2 py-2 sm:py-2
    rounded-lg text-white font-semibold
    text-sm sm:text-base
    bg-primaryAccent
    transition-all duration-300
    hover:bg-primaryAccentHover hover:shadow-lg
    active:scale-[0.97]"
                >
                  Subscribe
                  <span
                    className="bg-[#082344]
      p-2 sm:p-3
      rounded-lg
      group-hover:translate-x-1
      transition-all"
                  >
                    <FaArrowRight size={12} className="sm:hidden" />
                    <FaArrowRight size={14} className="hidden sm:block" />
                  </span>
                </button>
              </div>
            </div>

            {/* COMPANY + RESOURCES */}
            <div className="md:col-span-2 grid grid-cols-2 gap-8  lg:pl-10">
              {footerSections.map((section) => (
                <div key={section.title} className="flex flex-col  gap-5">
                  <p className="text-white font-semibold text-sm tracking-wide uppercase">
                    {section.title}
                  </p>

                  <div className="flex flex-col gap-3">
                    {section.links.map((item) => (
                      <span
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        className="text-gray-400 text-sm cursor-pointer transition-colors hover:text-white flex items-center gap-2"
                      >
                        {item.label}

                        {item.badge && (
                          <span
                            className="px-2 py-0.5 rounded text-white font-bold text-[10px]"
                            style={{ background: "#e05020" }}
                          >
                            {item.badge}
                          </span>
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* CONTACT */}
            <div className="flex flex-col gap-5">
              <p className="text-white font-semibold text-sm tracking-wide uppercase">
                Contact Us
              </p>

              <div className="flex flex-col gap-4 text-sm">
                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">
                    Call Us
                  </p>
                  <p className="text-gray-200 hover:text-white transition-colors">
                    912 4001 120 | 912 4001 145
                  </p>
                </div>

                <div>
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">
                    Mail Us
                  </p>
                  <p className="text-gray-200 hover:text-white transition-colors">
                    sales@mixmasters.in
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ADDRESS + SOCIAL */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2 flex-wrap justify-center md:justify-start">
              <span className="text-gray-200 text-sm font-medium tracking-wider uppercase">
                Follow Us On :
              </span>

              {socialIcons.map(({ name, icon: Icon, link }) => (
                <div
                  key={name}
                  className="social-icon cursor-pointer"
                  onClick={() =>
                    window.open(link, "_blank", "noopener,noreferrer")
                  }
                >
                  <Icon className="text-gray-50 size-5" />
                </div>
              ))}
            </div>

            <p className="text-gray-300 text-xs tracking-wide text-center md:text-right">
              Mix Masters RMC (India) Pvt. Ltd., Plot no- 270/1410, Pitapalli
              Square, Bhubaneswar
            </p>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="border-t py-4 mt-4 border-descriptionText">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-400 text-xs text-center sm:text-left leading-relaxed">
              © {currentYear}
              <span className="font-semibold ml-1 text-primaryAccent">
                Mix Master RMC
              </span>
              <span className="mx-1">•</span>
              All rights reserved
              {/* <span className="mx-1">•</span>
              Developed by
              <span
                onClick={() => window.open("https://webbocket.com/", "_blank")}
                className="font-semibold ml-1 text-gray-400 cursor-pointer hover:underline"
              >
                Web_Bocket
              </span> */}
            </p>

            {/* <div className="flex items-center gap-4 sm:gap-5 flex-wrap justify-center">
              {[
                { label: "Terms & Conditions", path: "/termsandconditions" },
              ].map((item) => (
                <span
                  key={item.label}
                  onClick={() => item.path && navigate(item.path)}
                  className="text-gray-400 text-xs hover:text-primaryAccent cursor-pointer transition-colors"
                >
                  {item.label}
                </span>
              ))}
            </div> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default UserFooter;
